import { NotificationStatus } from "@gtpl/shared-models/common-models";
import { ForkLiftJobStatus } from "@gtpl/shared-models/warehouse-management";
import {Column,Entity,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";


@Entity('notification')
export class Notifications {
    @PrimaryGeneratedColumn('increment', { name: 'notification_id' })
    notificationId: number;

    @Column('integer', {
        nullable: false,
        name: 'plant_id'
    })
    plantId: number;

    @Column('integer', {
        nullable: false,
        name: 'pallet_id'
    })
    palletId: number;

    @Column('integer', {
        nullable: false,
        name: 'job_id'
    })
    jobId: number;

    // @Column({
    //     type: 'enum',
    //     enum: ForkLiftJobStatus,
    //     nullable: false,
    //     name: 'status',
    //     default:"Open",
    // })
    // status: ForkLiftJobStatus;

    @Column({
        type: 'enum',
        enum: NotificationStatus,
        nullable: false,
        name: 'status',
        default:"Open",
    })
    status: NotificationStatus;

    @Column("text", {
        nullable: true,
        name: "status_msg"
    })
    statusMsg: string;  

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active',
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime',
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag',
    })
    versionFlag: number;

}
